import * as React from 'react';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { UnscrollableContainer } from '../../../../../misc';
import { Input, Label } from './styles';
import { H2 } from '../signInvigilatorRecords/styles';
import { InputErrMess, InputWrap } from '../addStudent/styles';
import { useMutation } from '@apollo/client';
import { AddPaymentConfigMutation } from '../../../../../generated/graphql';
import { ADD_PAYMENT_CONFIG } from './graphql';
import { BeatLoader } from 'react-spinners';
import { toast } from 'react-toastify';

export const Settings: React.FC = (): JSX.Element => {
  const [setPaymentConfig, { loading }] = useMutation<AddPaymentConfigMutation>(ADD_PAYMENT_CONFIG);

  const validationSchema = Yup.object().shape({
    smInvigilationRate: Yup.number().required('* Please provide senior member rate per hour'),
    nsmInvigilationRate: Yup.number().required('* Please provide non senior member rate per hour'),
    tax: Yup.number().required('* Please provide tax value'),
    snackRate: Yup.number().required('* Please provide snack rate per session'),
  });
  const initialValues = {
    smInvigilationRate: '',
    nsmInvigilationRate: '',
    tax: '',
    snackRate: '',
  };
  const { handleBlur, handleChange, handleSubmit, handleReset, values, errors } = useFormik({
    validationSchema,
    initialValues,
    onSubmit: async (formValues) => {
      const { smInvigilationRate, snackRate, nsmInvigilationRate, tax } = formValues;
      try {
        await setPaymentConfig({
          variables: { paymentConfig: { smInvigilationRate, snackRate, nsmInvigilationRate, tax } },
        });
        toast.success('Payment configuration updated!');
      } catch (err) {
        toast.error(err.message || 'Error occured in setting payment configirations!');
      }
    },
  });

  return (
    <UnscrollableContainer>
      <div className="ml-10">
        <H2 className="text-blue-700 my-12">Settings</H2>
        <form onSubmit={handleSubmit}>
          <div className="w-4/6 bg-gray-100 p-14 rounded-xl flex flex-col gap-9">
            <div>
              <h3 className="font-bold mb-2">Set rates per hour for each member</h3>
              <div className="flex gap-14 mt-2">
                <InputWrap>
                  <Label>senior member</Label>
                  <Input
                    type="number"
                    name="smInvigilationRate"
                    placeholder="eg. 30"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.smInvigilationRate}
                  />
                  <InputErrMess>{errors.smInvigilationRate}</InputErrMess>
                </InputWrap>
                <InputWrap>
                  <Label>non-senior member</Label>
                  <Input
                    type="number"
                    name="nsmInvigilationRate"
                    placeholder="eg. 15"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.nsmInvigilationRate}
                  />
                  <InputErrMess>{errors.nsmInvigilationRate}</InputErrMess>
                </InputWrap>
              </div>
            </div>
            <InputWrap>
              <Label>Set snack rate per sesssion</Label>
              <Input
                type="number"
                name="snackRate"
                placeholder="eg. 10"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.snackRate}
              />
              <InputErrMess>{errors.snackRate}</InputErrMess>
            </InputWrap>
            <InputWrap>
              <Label>Set tax</Label>
              <Input
                type="number"
                name="tax"
                placeholder="eg. 1"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.tax}
              />
              <InputErrMess>{errors.tax}</InputErrMess>
            </InputWrap>
          </div>
          <div className="flex gap-4 mt-8">
            <button
              className="px-6 py-2 font-bold 
             bg-red-600 rounded-xl text-white hover:bg-red-700"
              onClick={handleReset}
            >
              Clear
            </button>
            <button
              className="px-6 py-2 font-bold bg-blue-600 hover:bg-blue-700 rounded-xl text-white"
              type="submit"
            >
              {loading ? <BeatLoader size={10} color="#fff" /> : 'Save'}
            </button>
          </div>
        </form>
      </div>
    </UnscrollableContainer>
  );
};
